module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic_1.4d74d4bf.woff";